/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import RelatedLinks from '@nmx/template/dist/componentLibrary/layout/Footer/RelatedLinks';

export const RelatedLinksStyled = styled(RelatedLinks)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();

    return css`
      padding-bottom: 0;
      .nmx-row {
        padding-bottom: ${mediumUp ? rem(44) : rem(36)};
        border-bottom: ${rem(1)} solid ${theme.colors.neutral.gray};
      }
    `;
  }}
`;
